export default __webpack_public_path__ + "static/media/CarouselArrowRight.8899878e.svg";